import { Colors } from '../consts/Colors.js';
import AbstractScene from './AbstractScene.js';
import ButtonRounded from '../prefabs/ButtonRounded.js';
import { Sizes } from '../consts/Sizes.js';
import introJS from '../data/Intro.js';
import TitreJeu from '../prefabs/TitreJeu.js';
import GameNavTitre from '../prefabs/GameNavTitre.js';

export default class Intro extends AbstractScene {
    constructor() {
        super({ key: 'Intro' });
    }

    init(data) {
        this._init(data);
    }

    preload() {
        this._preload();
        this.videoKey = 'introVideo';
        this.preTarget = () => this.scene.start('Intro');
        this.postTarget = () => this.scene.start('Mission1');
        this.allControls = [];
        this.isDraging = false;
        this.isPlaying = false;
    }

    update() {
        super.update();
    }

    create() {
        this.cameras.main.setBackgroundColor(Colors.Elmt.PaleWhite);

        this.startIntro();
    }

    startIntro() {
        // Load intro data based on language
        const IntroData = this.getMissionData(introJS);

        this.videoKey = IntroData.videoKey;

        // 🔹 1. Add and store background image
        const background = this.add.image(0, 0, 'background').setOrigin(0, 0).setScale(1);

        // 🔹 2. Add and store logo
        const logo = this.add.image(56, 0, 'logo').setOrigin(0, 0).setDepth(1);

        // 🔹 3. Add title
        const titre = this.add.existing(
            new TitreJeu(
                this,
                56,
                this.height / 2 - 70,
                this.game.data.IntroData.titre,
                this.game.data.IntroData.soustitre,
                this.game.data.IntroData.description,
                this.width - 100,
                this.scaleY
            )
        );

        // 🔹 4. Create hidden name tag (opacity 0)
        const nameTag = this.add.existing(
            new GameNavTitre(this, 50, 0, '1', this.game.data.IntroData.nameTag, this.scaleX, false)
        );

        // 🔹 5. Add the button
        const button = this.add.existing(
            new ButtonRounded(
                this,
                56 + 163 + 30,
                this.cameras.main.height - 100,
                163 * 2,
                32 * 2,
                this.game.data.IntroData.buttonIntro,
                Colors.Text.DarkBlue,
                Colors.Elmt.White,
                false,
                Colors.Text.White,
                true,
                false,
                'arrow-right',
                null
            )
        );

        this.scaleX = 2.8;
        this.scaleY = 2;

        // add intro screen
        // Rectangle covering the entire screen
        /*  this.introBack = this.add
      .rectangle(
        this.width / 2,
        this.height / 2,
        this.width,
        this.height,
        Colors.Elmt.White
      )
      .setOrigin(0.5)
      .setDepth(2); */
        /*  this.introLogo = this.add
      .image(
        this.width / 2,
        this.height / 2,
        this.getText("Intro", "logoImage")
      )
      .setOrigin(0.5)
      .setScale(0.5)
      .setDepth(2);

    this.time.delayedCall(1500, () => {
      this.tweens.add({
        targets: [this.introBack, this.introLogo],
        alpha: 0,
        duration: 500,
        ease: "Sine.easeInOut",
      });
    }); */

        // 🔹 6. Ajouter images menu
        const rectangle1 = this.add
            .rexRoundRectangle(
                143 * this.scaleX + 133,
                84.5 * this.scaleY + 171,
                133 * 2,
                171 * 2,
                16,
                null, // No fill color for transparency
                2 // Stroke thickness
            )
            .setStrokeStyle(2, Colors.Elmt.White) // Set stroke color and thickness
            .setOrigin(0.5)
            .setAlpha(0)
            .setScale(0);

        const imageRectangle1 = this.add
            .image(
                169.5 * this.scaleX + 161 / this.scaleX,
                100.5 * this.scaleY + 129 / this.scaleY,
                'hat1'
            )
            .setOrigin(0.5)
            .setAlpha(0)
            .setScale(0);

        const buttonRectangle1 = this.add
            .existing(
                new ButtonRounded(
                    this,
                    159 * this.scaleX + 90,
                    188.5 * this.scaleY + 32,
                    101 * 2,
                    32 * 2,
                    this.game.data.IntroData.buttonDeb,
                    Colors.Text.DarkBlue,
                    Colors.Elmt.White,
                    false,
                    Colors.Text.White,
                    true,
                    false,
                    'arrow-right',
                    null
                )
            )
            .setAlpha(0)
            .setScale(0);

        buttonRectangle1.on('pointerdown', () => {
            this.game.data.level = 0;
            buttonRectangle1.destroy();
            buttonRectangle2.destroy();
            imageRectangle1.destroy();
            imageRectangle2.destroy();
            rectangle1.destroy();
            rectangle2.destroy();
            textRectangle1.destroy();
            textRectangle2.destroy();
            background.destroy();

            this.showVideo(this.videoKey); // une fois chargée, on affiche et on contrôle
        });

        const textRectangle1 = this.add
            .rexTagText(
                184 * this.scaleX + 25,
                224.5 * this.scaleY + 15,
                this.game.data.IntroData.ageDeb,
                {
                    fontSize: Sizes.Text.p,
                    color: Colors.Text.White,
                    fontFamily: 'Monteserrat',
                    backgroundColor: 'transparent',
                }
            )
            .setOrigin(0.5)
            .setAlpha(0)
            .setScale(0);

        const rectangle2 = this.add
            .rexRoundRectangle(
                292 * this.scaleX + 133,
                84.5 * this.scaleY + 171,
                133 * 2,
                171 * 2,
                16,
                null, // No fill color for transparency
                2 // Stroke thickness
            )
            .setStrokeStyle(2, Colors.Elmt.White) // Set stroke color and thickness
            .setOrigin(0.5)
            .setAlpha(0)
            .setScale(0);

        const buttonRectangle2 = this.add
            .existing(
                new ButtonRounded(
                    this,
                    308 * this.scaleX + 90,
                    188.5 * this.scaleY + 32,
                    101 * 2,
                    32 * 2,
                    this.game.data.IntroData.buttonExp,
                    Colors.Text.DarkBlue,
                    Colors.Elmt.White,
                    false,
                    Colors.Text.White,
                    true,
                    false,
                    'arrow-right',
                    null
                )
            )
            .setAlpha(0)
            .setScale(0);

        buttonRectangle2.setInteractive({ useHandCursor: true });
        buttonRectangle2.on('pointerdown', () => {
            this.game.data.level = 1;
            buttonRectangle1.destroy();
            buttonRectangle2.destroy();
            imageRectangle1.destroy();
            imageRectangle2.destroy();
            rectangle1.destroy();
            rectangle2.destroy();
            textRectangle1.destroy();
            textRectangle2.destroy();
            background.destroy();
            this.showVideo(this.videoKey);
        });

        const textRectangle2 = this.add
            .rexTagText(
                332.5 * this.scaleX + 25,
                224.5 * this.scaleY + 15,
                this.game.data.IntroData.ageExp,
                {
                    fontSize: Sizes.Text.p,
                    color: Colors.Text.White,
                    fontFamily: 'Monteserrat',
                    backgroundColor: 'transparent',
                }
            )
            .setOrigin(0.5)
            .setAlpha(0)
            .setScale(0);

        const imageRectangle2 = this.add
            .image(
                318.5 * this.scaleX + 161 / this.scaleX,
                100.5 * this.scaleY + 129 / this.scaleY,
                'hat2'
            )
            .setOrigin(0.5)
            .setAlpha(0)
            .setScale(0);

        // 🔹 7. Click event with combined tweens
        button.on('pointerdown', () => {
            const targetY = this.cameras.main.height - background.height * background.scaleY;

            // Déplacement du fond
            this.tweens.add({
                targets: background,
                y: targetY,
                duration: 1500,
                ease: 'Sine.easeInOut',
                onComplete: () => {
                    // ✨ Étape 1 : apparition simultanée des rectangles + images
                    this.tweens.add({
                        targets: [rectangle1, imageRectangle1, rectangle2, imageRectangle2],
                        alpha: 1,
                        scale: 1,
                        duration: 500,
                        ease: 'Back.easeOut', // léger rebond subtil
                        onComplete: () => {
                            // ✨ Étape 2 : apparition en cascade
                            const elements = [
                                buttonRectangle1,
                                textRectangle1,
                                buttonRectangle2,
                                textRectangle2,
                            ];
                            this.animateInOrder(this, elements, 0, 300);
                        },
                    });
                },
            });

            // fadeOut titre et button
            this.tweens.add({
                targets: [titre, button],
                alpha: 0,
                duration: 1000,
                ease: 'Sine.easeInOut',
            });

            // Scale du logo
            this.tweens.add({
                targets: logo,
                alpha: 0,
                duration: 500,
                ease: 'Sine.easeInOut',
            });

            // Fade in du nameTag
            this.tweens.add({
                targets: nameTag,
                y: 20,
                duration: 1500,
                ease: 'Sine.easeInOut',
            });
        });
    }

    animateInOrder(scene, targets, index = 0, duration = 300) {
        if (index >= targets.length) return;
        scene.tweens.add({
            targets: targets[index],
            alpha: 1,
            scale: 1,
            duration,
            ease: 'Back.easeOut',
            onComplete: () => this.animateInOrder(scene, targets, index + 1, duration),
        });
    }
}
